<template>
<Box @close="cerrar(false)" v-if="transferencia_items">
    <template #top>
        Orden de Ingreso Almacén: {{ transferencia_items.tfi_codigo }}
    </template>
    <template #center>
        <div class="nj-card">
            <div class="nj-grid">
                <LabelGroup label="Tipo transferencia" :value="transferencia_items.tfi_tipo_nombre"></LabelGroup>
                <LabelGroup label="Orden de compra" :value="transferencia_items.ord_code" v-if="isOrdenCompra"></LabelGroup>
                <LabelGroup label="Guia Remisión" :value="transferencia_items.tfi_guia_remision" v-if="isEntreAlmacenes"></LabelGroup>
                <LabelGroup label="Almacen origen" :value="transferencia_items.alm_origen_nombre" v-if="isEntreAlmacenes"></LabelGroup>
                <LabelGroup label="Almacen destino" :value="transferencia_items.alm_destino_nombre"></LabelGroup>
                <LabelGroup label="Transferido por" :value="transferencia_items.tfi_usu_registrador_nombre"></LabelGroup>
                <LabelGroup label="Fecha envio" :value="transferencia_items.tfi_fecha_registro"></LabelGroup>
                <LabelGroup label="Fecha recepción" :value="transferencia_items.tfi_fecha_ingreso"></LabelGroup>
                <LabelGroup label="Recepcionado por" :value="transferencia_items.tfi_usu_recepcionador_nombre"></LabelGroup>
                <LabelGroup label="Orden de ingreso almacén" :value="transferencia_items.tfi_codigo"></LabelGroup>
            </div>
            <br>
            <b-table :data="transferencia_items.lista_transferencia_items_detalle" :sort-icon="sortIcon" :sort-icon-size="sortIconSize">
                <template slot-scope="props">
                    <b-table-column label="Producto" header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                    <b-table-column label="Cantidad" header-class="is-info" style="width: 100px;">{{ props.row.tid_cantidad }}</b-table-column>
                    <b-table-column label="Cantidad ingresada" header-class="is-info" style="width: 100px;">{{ props.row.tid_ingreso_cantidad }}</b-table-column>
                    <b-table-column label="Notas" header-class="is-info">{{ props.row.tid_ingreso_notas }}</b-table-column>
                </template>
            </b-table>
        </div>
    </template>
</Box>
</template>

<script>
import { ResponseStatus, TransferenciaItemsService } from "../../rest"
import { Data } from "../../util"
import Toast from "../../util/toast"
import { Box, LabelGroup } from "../components"
export default {
    name: "TransferenciaItemsView",
    components: {
        LabelGroup,
        Box,
    },
    props: {
        tfi_id: {
            type: Number
        }
    },
    computed: {
        isOrdenCompra() {
            return this.transferencia_items.tfi_tipo == Data.tipoTransferencia.ordenCompra.tit_id
        },
        isEntreAlmacenes() {
            return this.transferencia_items.tfi_tipo == Data.tipoTransferencia.entreAlmacenes.tit_id
        },
    },
    data() {
        return {
            transferencia_items: null,
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
        }
    },
    methods: {
        cerrar(condition) {
            this.$emit("close", condition)
        },
        obtener() {
            TransferenciaItemsService
                .obtener({
                    transferencia_items: {
                        tfi_id: this.tfi_id
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.transferencia_items = response.data
                    }
                    else {
                        Toast.warn(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
    },
    mounted() {
        this.obtener()
    }
}
</script>

<style scoped></style>